import { store } from '../stores';
import { updateTokens, clearAuth } from '../stores/authSlice';

type AuthBroadcastMessage =
  | { type: 'TOKEN_REFRESH'; accessToken: string; refreshToken: string }
  | { type: 'LOGOUT' };

const AUTH_CHANNEL_NAME = 'auth-sync';

let _channel: BroadcastChannel | null = null;

function initChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (_channel) return _channel;

  _channel = new BroadcastChannel(AUTH_CHANNEL_NAME);
  _channel.onmessage = ({ data }: MessageEvent<AuthBroadcastMessage>) => {
    if (data.type === 'TOKEN_REFRESH') {
      store.dispatch(updateTokens({ accessToken: data.accessToken, refreshToken: data.refreshToken }));
      // Notifica authUtils di riprogrammare il proactive refresh con i nuovi token
      window.dispatchEvent(new CustomEvent('auth:tokens-synced', { detail: data.accessToken }));
    } else if (data.type === 'LOGOUT') {
      store.dispatch(clearAuth());
    }
  };

  return _channel;
}

export function broadcastTokenRefresh(accessToken: string, refreshToken: string): void {
  initChannel()?.postMessage({ type: 'TOKEN_REFRESH', accessToken, refreshToken } as AuthBroadcastMessage);
}

export function broadcastLogout(): void {
  initChannel()?.postMessage({ type: 'LOGOUT' } as AuthBroadcastMessage);
}

// Inizializza il listener all'import del modulo così tutti i tab ricevono i messaggi
initChannel();
